import { render, staticRenderFns } from "./VRScores.vue?vue&type=template&id=479b52f4"
import script from "./VRScores.vue?vue&type=script&lang=js"
export * from "./VRScores.vue?vue&type=script&lang=js"
import style0 from "./VRScores.vue?vue&type=style&index=0&id=479b52f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports